import { useState } from 'react';
import { assessmentAPI, ApiResult } from '../../../../services/api';

interface UseAssessmentPDFReturn {
  pdfDownloading: boolean;
  handlePDFDownload: (assessmentId: string) => Promise<ApiResult | undefined>;
}

export const useAssessmentPDF = (): UseAssessmentPDFReturn => {
  const [pdfDownloading, setPdfDownloading] = useState(false);

  const handlePDFDownload = async (assessmentId: string): Promise<ApiResult | undefined> => {
    if (!assessmentId) {
      console.error('Assessment ID is required for PDF download');
      return;
    }

    setPdfDownloading(true);
    try {
      const result = await assessmentAPI.getAssessmentPDF(assessmentId);
      if (result.success && result.data instanceof Blob) {
        // Handle file download - result.data is already a Blob
        const url = globalThis.URL.createObjectURL(result.data);
        const a = document.createElement('a');
        a.href = url;
        a.download = `assessment-report-${assessmentId}.pdf`;
        document.body.appendChild(a);
        a.click();
        globalThis.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        return result;
      } else {
        throw new Error(result.error || 'Failed to download PDF');
      }
    } catch (error) {
      console.error('Error downloading PDF:', error);
      throw error;
    } finally {
      setPdfDownloading(false);
    }
  };

  return {
    pdfDownloading,
    handlePDFDownload
  };
};

export default useAssessmentPDF;
